module.exports = __webpack_public_path__ + "img/ep3-2.c8cb6262.jpg";